module.exports = __webpack_public_path__ + "img/logoL.c5004d86.svg";